import React, { memo, useCallback } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { AtmosphericLogDropzone } from 'Components/RocketDry';
import { useDropzone } from 'react-dropzone';

interface Props {
  setPhoto: any;
}

function AtmosphericLogDropzoneContainer({ setPhoto }: Props) {
  // on file drop
  const onDrop = useCallback(async (acceptedFiles: any[], rejectedFiles: any[]) => {
    // show error toast
    if (rejectedFiles.length > 0) {
      // dispatch(showToast());
    }
    if (acceptedFiles.length > 0) {
      const photo = acceptedFiles[0];
      setPhoto(photo);
    }

    return true;
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ['image/jpeg', 'image/png'],
  });

  return <AtmosphericLogDropzone getRootProps={getRootProps} getInputProps={getInputProps} />;
}

const AtmosphericLogDropzoneContainerMemo = memo(AtmosphericLogDropzoneContainer, areEqual);
export { AtmosphericLogDropzoneContainerMemo as AtmosphericLogDropzone };
